/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { ComponentChildren, Fragment } from 'preact';
import { ItemContext } from '../UNSAFE_Collection';

/**
 * Props for the Collection Component
 */
export type Props<D> = {
  /**
   * An array of data
   */
  items: D[];
  /**
   * A function to render each item
   */
  children: (context: ItemContext<D>) => ComponentChildren;
};

/**
 * Component that renders an array of data.
 */
export function Collection<D>({ items, children }: Props<D>) {
  return (
    <Fragment>
      {items.map((data: D, index: number) => {
        const ctx = { index, data };
        return children(ctx);
      })}
    </Fragment>
  );
}
